import { getCustomIcon } from 'owa-mini-icons';
import { getStore } from 'owa-mail-store/lib/store/Store';

/**
 * Returns the custom icon for folder.
 * If the folder is top level folder and doesn't have any child folders, returns custom icon if present or folder icons
 * If the folder is not top level folder it returns no icon
 * @param folderId FolderId
 */
export default function getDefaultIconForFolder(folderId: string, isFavorite: boolean): string {
    const mailStore = getStore();
    const childFolderIds =
        mailStore.folders &&
        mailStore.folders.rootFolder &&
        mailStore.folders.rootFolder.childFolderIds;

    return isFavorite || childFolderIds.indexOf(folderId) > -1 ? getCustomIcon(folderId) : null;
}
